<fui-icon class="icon" [icon]="'information'" [height]="18" [width]="18"></fui-icon>
<div class="text">
    <span class="text-title" [innerHTML]="title | translate: titleParams"></span>
    <span class="text-message" [innerHTML]="message | translate: messageParams"></span>
    <div class="text-message"><ng-content></ng-content></div>
</div>
